export const COUNTRY_NAMES = {
  kz: {
    default: 'Казахстан',
    genitive: 'Казахстане',
  },
  kg: {
    default: 'Бишкек',
    genitive: 'Бишкеке',
  },
}

export const PARCEL_DELIVERY_ANNOTATION = {
  kz: 'Самовывоз доступен в Алматы по адресу: <a href="https://go.2gis.com/vemeh" target="_blank">Розыбакиева 238а</a>. C 10:00 до 19:00',
  kg: 'Самовывоз доступен в Бишкеке по адресу: <a href="https://go.2gis.com/o8hnt" target="_blank">Московская, 139</a>. C 10:00 до 19:00',
}

export const INSTAGRAM_ACCOUNT = {
  kz: 'shipper.kz',
  kg: 'shipperkg',
}
export const GOOGLE_ANALYTICS_ID = {
  kz: 'UA-126462280-1',
  kg: 'UA-126462280-2',
}
export const YANDEX_METRIKA_ID = {
  kz: 50488192,
  kg: 67820392,
}
export const CONTACTS = {
  kz: {
    tel: {
      raw: '+77472053355',
      formatted: '+7 (747) 205-33-55',
    },
    email: 'fast@shipper.kz',
  },
  kg: {
    tel: {
      raw: '+996707335522',
      formatted: '+996 (707) 33-55-22',
    },
    email: 'fast@shipper.kg',
  },
}

export const SUPPORT_URL = 'https://t.me/fastshipper_bot'

export const PROTECTED_ROUTES = [
  '/add-parcel',
  '/calculator',
  '/address',
  '/help',
  '/parcels',
  '/shops',
  '/transactions',
  '/user-settings',
]
export const SECTION_KEYS = {
  SIMPLE_STEPS: 'simple-steps',
  ABOUT_DELIVERY: 'about-delivery',
  CALCUCATE: 'calculate',
  EXAMPLES: 'examples',
  FAQ: 'faq',
}

import type { MessageKey } from './types/i18n'

export type ParcelStatusNavItem = {
  statusSlug: string | null
  labelKey: MessageKey
  href: string
}

export const PARCEL_STATUS_NAV_ITEMS: Array<ParcelStatusNavItem> = [
  {
    statusSlug: null,
    labelKey: 'dashboardNav.parcelItems.all',
    href: '/parcels',
  },
  {
    statusSlug: 'new',
    labelKey: 'dashboardNav.parcelItems.new',
    href: '/parcels/status/new',
  },
  {
    statusSlug: 'prepayment-invoice',
    labelKey: 'dashboardNav.parcelItems.prepaymentInvoice',
    href: '/parcels/status/prepayment-invoice',
  },
  {
    statusSlug: 'packaging',
    labelKey: 'dashboardNav.parcelItems.packaging',
    href: '/parcels/status/packaging',
  },
  {
    statusSlug: 'executing',
    labelKey: 'dashboardNav.parcelItems.executing',
    href: '/parcels/status/executing',
  },
  {
    statusSlug: 'final-invoice',
    labelKey: 'dashboardNav.parcelItems.finalInvoice',
    href: '/parcels/status/final-invoice',
  },
  {
    statusSlug: 'on-delivery',
    labelKey: 'dashboardNav.parcelItems.onDelivery',
    href: '/parcels/status/on-delivery',
  },
  {
    statusSlug: 'won',
    labelKey: 'dashboardNav.parcelItems.won',
    href: '/parcels/status/won',
  },
]

export type MainNavItem = {
  labelKey: MessageKey
  href: string
}

export const MAIN_NAV_ITEMS: Array<MainNavItem> = [
  {
    labelKey: 'dashboardNav.userItems.calculator',
    href: '/calculator',
  },
  {
    labelKey: 'dashboardNav.userItems.address',
    href: '/address',
  },
  {
    labelKey: 'dashboardNav.userItems.recipients',
    href: '/recipients',
  },
  {
    labelKey: 'dashboardNav.userItems.transactions',
    href: '/transactions',
  },
  {
    labelKey: 'dashboardNav.userItems.help',
    href: '/help',
  },
  {
    labelKey: 'dashboardNav.userItems.settings',
    href: '/user-settings',
  },
]

export const SECTIONS = [
  {
    key: SECTION_KEYS.SIMPLE_STEPS,
    nameKey: 'homeSections.simpleSteps',
  },
  {
    key: SECTION_KEYS.ABOUT_DELIVERY,
    nameKey: 'homeSections.aboutDelivery',
  },
  {
    key: SECTION_KEYS.CALCUCATE,
    nameKey: 'homeSections.calculate',
  },
  {
    key: SECTION_KEYS.EXAMPLES,
    nameKey: 'homeSections.examples',
  },
  {
    key: SECTION_KEYS.FAQ,
    nameKey: 'homeSections.faq',
  },
]

export const INSURANCE_BASE_PERCENTAGE = 3
export const INSURANCE_MIN_AMOUNT = 300
